import { AxiosResponse } from 'axios'

import {
  cancelNpSession,
  NpCancelSessionRequest,
} from '@lyrahealth-inc/shared-app-logic/src/features/npTesting/cancelNpSession'
import {
  getNpScheduleSessionsPath,
  getNpSessionsPath,
  NP_AVAILABLE_TIMES_PATH,
} from '@lyrahealth-inc/shared-app-logic/src/features/npTesting/constants'
import {
  NpAvailableTimesRequest,
  NpAvailableTimesResponse,
  NpScheduleSessionsRequest,
  NpScheduleSessionsResponse,
  NpSessionsResponse,
} from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { axiosInstance } from '../axiosInstance'

export const deleteNpSession = (request: NpCancelSessionRequest) => cancelNpSession(axiosInstance, request)

export const postNpAvailableTimes = (
  request: NpAvailableTimesRequest,
): Promise<AxiosResponse<NpAvailableTimesResponse>> => {
  return axiosInstance.post(NP_AVAILABLE_TIMES_PATH, request)
}

export const postNpScheduleSessions = (
  userLyraId: string,
  request: NpScheduleSessionsRequest,
): Promise<AxiosResponse<NpScheduleSessionsResponse>> => {
  return axiosInstance.post(getNpScheduleSessionsPath(userLyraId), request)
}

/**
 * Every session in the member's NP episode. Booked sessions will include info about the appointment and
 * the provider that the appointment is booked with. `userLyraId` is the id of the person being booked for.
 */
export const getNpSessions = (userLyraId: string): Promise<AxiosResponse<NpSessionsResponse>> => {
  return axiosInstance.get(getNpSessionsPath(userLyraId))
}
